import { useSelector } from 'react-redux'
import { URLS } from '../../const/nav'
import { authFetch } from '../../services/authFetch'

export const useFinishStudy = () => {
  const { user, evaluations } = useSelector(state => state)
  const id = evaluations ? evaluations.id : JSON.parse(sessionStorage.getItem('_idStudy'))

  const finishStudy = async (
    status,
    observacionFinal = '',
    motivo_envio_mala_calidad = '',
    motivo_decision_tecnico
  ) => {
    try {
      const body = {
        referir: status,
        motivo_envio_mala_calidad: motivo_envio_mala_calidad
      }

      if (observacionFinal !== undefined && observacionFinal !== null && String(observacionFinal).trim() !== '') {
        body.observacion = String(observacionFinal).trim()
      }

      if (motivo_decision_tecnico !== undefined && motivo_decision_tecnico !== null && String(motivo_decision_tecnico).trim() !== '') {
        body.motivo_decision_tecnico = String(motivo_decision_tecnico).trim()
      }

      const r = await authFetch(`${URLS.BACKEND_URL}/estudios/finalizar/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${user.token}`
        },
        body: JSON.stringify(body)
      })

      if (r.ok) {
        return await r.json()
      } else {
        console.error('Error en la solicitud:', r.status, r.statusText)
        return null
      }
    } catch (error) {
      console.error('Error durante la solicitud:', error)
      return null
    }
  }

  return { finishStudy }
}
